export default {
  default: () => import("/var/www/minisite/layouts/default.vue").then(m => m.default || m)
}